import { cn } from '@/lib/utils';

/**
 * StatusDot · circular dot pulsante usado para señalizar estado
 * (operación viva, modo dark, agente activo, etc.).
 *
 * Usa CSS variables del design system (`--ok`, `--warn`, `--err`, `--info`,
 * `--brand`, `--fg-dim`) para que cambien automáticamente con dark/light.
 *
 * `src/index.css`.
 */
export type StatusTone =
  | 'default'
  | 'primary'
  | 'brand'
  | 'ok'
  | 'warn'
  | 'err'
  | 'info';

interface StatusDotProps {
  tone?: StatusTone;
  /** Si true, muestra un halo pulsante alrededor del dot. */
  size?: 'sm' | 'md';
  className?: string;
}

const TONE_CLASS: Record<StatusTone, string> = {
  default: '',
  primary: 'brand',
  brand: 'brand',
  ok: 'ok',
  warn: 'warn',
  err: 'err',
  info: 'info',
};

export function StatusDot({
  tone = 'ok',
  size = 'md',
  className,
}: StatusDotProps) {
  const sizeStyle =
    size === 'sm'
      ? { width: 5, height: 5 }
      : undefined;
  return (
    <span
      aria-hidden
      className={cn('status-dot', TONE_CLASS[tone], className)}
      style={sizeStyle}
    />
  );
}
